import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAccount } from "../../context/AccountContext";
import TemplateLibraryModal from "../../components/rules/TemplateLibraryModal";
import RuleCard from "../../components/rules/RuleCard";
import { STRATEGY_OPTIONS } from "../../constants/strategies";

const RulesPage = () => {
  const { selectedAccount } = useAccount();
  const [strategyType, setStrategyType] = useState("PYRAMID_HEDGING");
  const [rules, setRules] = useState([]);
  const [showTemplates, setShowTemplates] = useState(false);
  const [factRegistry, setFactRegistry] = useState([]);
  const [actionRegistry, setActionRegistry] = useState([]);

  const [saving, setSaving] = useState(false);
  const [removingId, setRemovingId] = useState(null);
  const [msg, setMsg] = useState(null);

  const flash = (text, ok = true) => {
    setMsg({ text, ok });
    setTimeout(() => setMsg(null), 3000);
  };

  const handleDeleteRule = async (rule, index) => {
    if (!window.confirm(`Remove rule "${rule.rule_name || "Unnamed Rule"}"? This cannot be undone.`)) return;
    if (rule.id) {
      setRemovingId(rule.id);
      try {
        await axios.delete(`/rules/delete/${rule.id}`);
      } catch (err) {
        flash(err.response?.data?.error || "Failed to remove rule.", false);
        setRemovingId(null);
        return;
      }
      setRemovingId(null);
    }
    setRules(prev => prev.filter((_, i) => i !== index));
    flash(`"${rule.rule_name || "Unnamed Rule"}" removed`);
  };

  const saveAllRules = async () => {
    if (!selectedAccount) return;

    try {
      setSaving(true);

      await axios.post("/rules/save-bulk", {
        username: selectedAccount,
        strategy_type: strategyType,
        rules: rules
      });

      alert("Rules saved successfully");
      fetchRules(); // reload clean data

    } catch (err) {
      console.error(err);
      alert("Error saving rules");
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    if (selectedAccount) {
      fetchRules();
      fetchRegistries();
    }
  }, [selectedAccount, strategyType]);

  const fetchRegistries = async () => {
  const facts = await axios.get("/rules/facts");
  const actions = await axios.get("/rules/actions");

  setFactRegistry(facts.data);
  setActionRegistry(actions.data);
};

  const fetchRules = async () => {
    const res = await axios.get(`/rules/${selectedAccount}/${strategyType}`);
    const parsed = res.data.map(r => ({
      id: r.id,
      ...JSON.parse(r.rule_json),
      is_active: r.is_active
    }));
    setRules(parsed);
  };

  const importTemplate = async (templateRules) => {
    await axios.post("/rules/activate-template", {
      username: selectedAccount,
      strategy_type: strategyType,
      rules: templateRules
    });
    fetchRules();
    setShowTemplates(false);
  };

  return (
  <div style={{ padding: 25, background: "#f4f6f9", minHeight: "100vh" }}>

    {msg && (
      <div style={{
        position: "fixed", top: 20, right: 20, zIndex: 9999,
        padding: "10px 20px", borderRadius: 8, color: "#fff",
        fontWeight: 600, fontSize: 14,
        background: msg.ok ? "#28a745" : "#dc3545"
      }}>
        {msg.text}
      </div>
    )}

    {/* TRADING RULES */}
    {<>
    <div style={{
      display: "flex",
      gap: "15px",
      marginBottom: "25px",
      alignItems: "center"
    }}>

      <select
        value={strategyType}
        onChange={(e) => setStrategyType(e.target.value)}
        style={inputStyle}
      >
        {STRATEGY_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        <option value="MONEY_MANAGEMENT">Money Management</option>
      </select>

      <button
        style={secondaryBtn}
        onClick={() => setShowTemplates(true)}
      >
        Import Template
      </button>

      <button
        style={primaryBtn}
        onClick={() =>
          setRules([
            ...rules,
            {
              rule_name: "New Rule",
              group_name: "DEFAULT",
              priority: 100,
              group_max_fires: 1,
              cooldown_minutes: 0,
              idempotency_ttl_minutes: 60,
              conditions_tree: { type: "AND", children: [] },
              actions: [],
              is_active: true
            }
          ])
        }
      >
        + New Rule
      </button>

      <button
        style={{
          ...primaryBtn,
          background: "#28a745"
        }}
        onClick={saveAllRules}
        disabled={saving}
      >
        {saving ? "Saving..." : "Save All Rules"}
      </button>

    </div>

    {rules.map((rule, index) => (
      <RuleCard
        key={rule.id || index}
        rule={rule}
        factRegistry={factRegistry}
        actionRegistry={actionRegistry}
        onChange={(updated) => {
          const copy = [...rules];
          copy[index] = updated;
          setRules(copy);
        }}
        onDelete={() => handleDeleteRule(rule, index)}
        removing={!!rule.id && removingId === rule.id}
      />
    ))}

    {showTemplates && (
      <TemplateLibraryModal
        strategyType={strategyType}
        onClose={() => setShowTemplates(false)}
        onImport={importTemplate}
      />
    )}
    </>}

  </div>
);
};

/* STYLES */

const inputStyle = {
  padding: "8px 12px",
  borderRadius: 8,
  border: "1px solid #ccc",
  fontSize: 13
};

const primaryBtn = {
  padding: "8px 14px",
  marginLeft: 10,
  borderRadius: 8,
  border: "none",
  background: "#007bff",
  color: "#fff",
  cursor: "pointer"
};

const secondaryBtn = {
  padding: "8px 14px",
  borderRadius: 8,
  border: "1px solid #ccc",
  background: "#fff",
  cursor: "pointer"
};

export default RulesPage;